import { css } from 'styled-components';

const defaultBreakpoints = {
  mobile: 0,
  tablet: 797,
  desktop: 1025,
};
const DEFAULT_FONT_SIZE = 16;
const FULL_WIDTH = 100;

const breakpoint = (name, breakpoints = defaultBreakpoints) => {
  const px = breakpoints[name];
  const ems = px / DEFAULT_FONT_SIZE;

  if (px === 0) {
    return (...args) => css(...args);
  }

  return (...args) => css`
    @media (min-width: ${ems}em) {
      ${css(...args)};
    }
  `;
};

const map = (val, fn, breakpoints) => {
  const type = typeof val;

  if (type === 'undefined') {
    return null;
  }

  if (type === 'object') {
    return Object.keys(val).map(key => breakpoint(key, breakpoints)(...fn(val[key])));
  } else {
    return fn(val);
  }
};

/*
    Width can be defined as a number or object
    Object would specify columns for each breakpoint
    <Component width={{mobile: 1, tablet: 1/2, desktop: 1/4}}>
 */
const widthMixin = ({ cols, theme }) =>
  map(
    cols,
    colw => {
      switch (colw) {
        case 'min': {
          return `
        flex-grow: 0;
        flex-basis: auto;
        width: auto;
        max-width: none;
        padding-right: 16px;
        padding-left: 16px;
      `;
        }
        case 'max': {
          return `
        flex-grow: 1;
        flex-basis: auto;
        width: auto;
        max-width: none;
        padding-right: 16px;
        padding-left: 16px;
      `;
        }
        default: {
          const pct = Math.round(colw * FULL_WIDTH * 10000) / 10000;
          return `
        box-sizing: border-box;
        flex: 0 0 auto;
        padding-right: 16px;
        padding-left: 16px;
        flex-basis: ${pct}%;
        max-width: ${pct}%;
      `;
        }
      }
    },
    theme.breakpoints
  );

export default widthMixin;
